import { queueTrackingEvent } from '@library/tracking-integration'

export type ForgotPasswordSource =
  | 'login_modal'
  | 'existing_email_login_modal'
  | 'reset_password_page'

export type ResetPasswordSubmitProperties =
  | { result: 'success' }
  | { result: 'error'; error_type: string }

type ForgotPasswordEvent = {
  action: 'forgot_password'
  category: 'funnel'
  properties: { source: ForgotPasswordSource }
}

type ResetPasswordLinkOpenEvent = {
  action: 'reset_password_link_open'
  category: 'funnel'
  properties: { navigation_type: string }
}

type ResetPasswordSubmitEvent = {
  action: 'reset_password_submit'
  category: 'funnel'
  properties: ResetPasswordSubmitProperties
}

export const trackForgotPasswordClicked = (source: ForgotPasswordSource) =>
  queueTrackingEvent<ForgotPasswordEvent>({
    action: 'forgot_password',
    category: 'funnel',
    properties: { source },
  })

export const trackResetPasswordLinkOpened = (navigationType: string) =>
  queueTrackingEvent<ResetPasswordLinkOpenEvent>({
    action: 'reset_password_link_open',
    category: 'funnel',
    properties: { navigation_type: navigationType },
  })

export const trackResetPasswordSubmitted = (properties: ResetPasswordSubmitProperties) =>
  queueTrackingEvent<ResetPasswordSubmitEvent>({
    action: 'reset_password_submit',
    category: 'funnel',
    properties,
  })
